(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name auditReport.service:AuditReportService
     *
     * @description
     *
     */
    angular
        .module('userActivityAuditReport')
        .service('UserActivityAuditReportService', UserActivityAuditReportService);

    function UserActivityAuditReportService(RemoteService, EventManagerService, applicationConstants,CommonDataModel, MessageService) {
        var self = this;
        self.model = {
          auditTemplateGroups: null,
          auditTemplateList: null,
          auditCreatedByList: null

        };

        self.getAuditTemplateGroups = function (successFn, errorFn) {
            if (self.model.auditTemplateGroups === null) {
                RemoteService.getAuditTemplateGroups().then(
                    function (response) {
                        self.model.auditTemplateGroups = response.templateGroupList;
                        successFn(self.model.auditTemplateGroups);
                    },
                    function (error) {
                        errorFn(error.msg);
                    }
                );
            } else {
                successFn(self.model.auditTemplateGroups);
            }
        };

        self.getAuditTemplateList = function (param, successFn, errorFn) {
            RemoteService.getAuditTemplateList(param).then(
              function (response) {
                self.model.auditTemplateList = response.templateList;
                successFn(self.model.auditTemplateList);
              },
              function (error) {
                errorFn(error.msg);
              }
            );
        };

        self.getAuditCreatedByList = function (successFn, errorFn) {
          if (self.model.auditCreatedByList === null) {
            RemoteService.getAuditCreatedByList().then(
              function (response) {
                self.model.auditCreatedByList = response.createdByList;
                successFn(self.model.auditCreatedByList);
              },
              function (error) {
                errorFn(error.msg);
              }
            );
          } else {
            successFn(self.model.auditCreatedByList);
          }
        };

    }
}());
